import React from "react";
import { Icon } from "rsuite";
import "./SpecialFeatures.layout.sass";
import Axios from "axios";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectInfo } from "../../redux/site/site.selector";
import { SetInfo } from "../../redux/site/site.actions";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import { Setting } from "../../setting";

class SpecialFeaturesLayout extends React.Component {
  componentDidMount() {
    const { setInfo } = this.props;

    Axios.get(`${Setting.apiUrl}api/feature/list`).then((res) => {
      setInfo(res.data.data);
    });
  }
  render() {
    const { getInfo } = this.props;
    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
      position: relative;
    `;
    return (
      <div>
        <div className="terms-layout">
          <div className="terms-container-div">
            <h3>
              <Icon icon="circle" /> ویژگی های منحصر به فرد{" "}
              <span>زیتونیکس</span>
            </h3>
            <br />
            {getInfo ? (
              getInfo.map((item, i) => (
                <div key={i}>
                  <h5>
                    <Icon icon="arrow-left" /> {item.title}
                  </h5>
                  <p>{item.descrption}</p>
                  <br />
                </div>
              ))
            ) : (
              <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  getInfo: selectInfo,
});
const mapDispatchToProps = (dispatch) => ({
  setInfo: (data) => dispatch(SetInfo(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpecialFeaturesLayout);
